<template>
    <div class="element-box">
        <div class="controls-above-table">
            <div class="row">
                <div class="col-sm-2">
                    <button type="button"
                    class="btn btn-sm btn-success"
                    @click="nuevoContacto"
                    >
                    <i class="fa fa-plus"></i>
                    Nuevo Contacto
                </button>
                    <a class href="#"></a>
                </div>
                <div class="col-sm-10">
                    <form
                    @submit="filterData"
                    action="#"
                    class="form-inline justify-content-sm-end"
                    >
                        <input
                            class="form-control form-control-sm rounded bright"
                            placeholder="Search"
                            v-model="searchtext"
                            type="text"
                        />
                        <div class="input-group-append">
                            <button class="btn btn-link btn-sm" type="submit">
                            <i class="fa fa-search"></i>
                            </button>
                            <button
                            class="btn btn-link btn-sm"
                            type="button"
                            v-on:click="clearFilterData"
                            >
                            <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <select
                            class="form-control form-control-sm rounded bright"
                            v-model="filterActivo"
                            @change="filterData"
                        >
                            <option selected value="null">Estado</option>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </select>
                        <select
                            class="form-control form-control-sm rounded bright"
                            v-model="filterCategoria"
                            @change="filterData"
                        >
                            <option selected value="">Categorías</option>
                            <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">
                                {{ categoria.nombre }}
                            </option>
                        </select>
                        <select categorias-contacto
                            class="form-control form-control-sm rounded bright"
                            v-model="filterRecibeCorreo"
                            @change="filterData"
                        >
                            <option selected value="null">¿Recibe correo?</option>
                            <option value="1">Recibe correo</option>
                            <option value="0">No recibe correo</option>
                        </select>
                        <select
                            class="form-control form-control-sm rounded bright"
                            v-model="filterCCOculto"
                            @change="filterData"
                        >
                            <option selected value="null">¿Con copia oculta?</option>
                            <option value="1">Con copia oculta</option>
                            <option value="0">Sin copia oculta</option>
                        </select>
                    </form>
                </div>
            </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div style="height: 300px; overflow: auto" class="table-responsive tableFixHead">
        <!-------------------- Tabla de REsultados -------------------->
        <table class="table table-invoice table-hover">
            <thead>
            <tr>
                <th>Correo</th>
                <th>Representante</th>
                <th>Teléfono 1</th>
                <th>Teléfono 2</th>
                <th>Extensión</th>
                <th>Categoría</th>
                <th class="text-center">Estado</th>
                <th class="text-center">¿Recibe Correo?</th>
                <th class="text-center">¿Con Copia Oculta?</th>
            </tr>
            </thead>
            <tbody>
                <tr 
                    v-for="contacto in contactos"
                    v-bind:key="contacto.id"
                    @click="rowClick(contacto)"  
                >
                    <td>{{ contacto.correo }}</td>
                    <td>{{ contacto.nombre }}</td>
                    <td>{{ contacto.telefono1 }}</td>
                    <td>{{ contacto.telefono2 }}</td>
                    <td>{{ contacto.extension }}</td>
                    <td>{{ contacto.categoria_contacto.nombre }}</td>
                    <td class="text-center">
                    <div
                        v-if="contacto.activo"
                        class="status-pill green"
                        data-title="Activo"
                        data-toggle="tooltip"
                    ></div>
                    <div
                        v-if="!contacto.activo"
                        class="status-pill red"
                        data-title="Inactivo"
                        data-toggle="tooltip"
                    ></div>
                    </td>
                    <td class="text-center">
                    <div
                        v-if="contacto.recibe_correo"
                        class="status-pill green"
                        data-title="Activo"
                        data-toggle="tooltip"
                    ></div>
                    <div
                        v-if="!contacto.recibe_correo"
                        class="status-pill red"
                        data-title="Inactivo"
                        data-toggle="tooltip"
                    ></div>
                    </td>
                    <td class="text-center">
                    <div
                        v-if="contacto.cc_oculto"
                        class="status-pill green"
                        data-title="Activo"
                        data-toggle="tooltip"
                    ></div>
                    <div
                        v-if="!contacto.cc_oculto"
                        class="status-pill red"
                        data-title="Inactivo"
                        data-toggle="tooltip"
                    ></div>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-------------------- END - Basic Table -------------------->
        </div>
    </div>
  </template>
  <script>
  import DynamicServiceService from "@/services/commons/DynamicService";
  import ContactoProveedorService from "@/services/catalogos/ContactoProveedorService";
  
  export default {
    components: {
      ContactoProveedorService
    },
    props: ["id_proveedor"],
    data() {
        return {
            filterCategoria:"",
            filterActivo: null,
            filterCCOculto: null,
            filterRecibeCorreo: null,
            searchtext: "",
            contactos: [],
            categorias: []
        };
    },
    watch:{
        id_proveedor(nuevoValor,antiguoValor) {
            if(nuevoValor){
                this.refreshData();
            }
        }
    },
    computed:{},
    mounted() {
    },
    methods: {
        changeFilterCCOculto(){
            this.filterCCOculto = !this.filterCCOculto;
            this.filterData();
        },
        changeFilterRecibeCorreo(){
            this.filterRecibeCorreo = !this.filterRecibeCorreo;
            this.filterData();
        },
        filterData(e) {
            e.preventDefault();
            this.refreshData();
        },
        clearFilterData() {
            this.filterActivo = null;
            this.filterCCOculto = null;
            this.filterRecibeCorreo = null;
            this.searchtext = "";
            this.refreshData();
        },
        refreshCategorias(){
            ContactoProveedorService.getCategorias()
            .then(response=>{
            this.categorias = response.data.results;
            })
        },
        refreshData() {
            let self = this;
            self.refreshCategorias();
            DynamicServiceService.fetch("cat","contactos-proveedor",{
                proveedor:this.id_proveedor,
                quitar_paginacion: true,
                "filter[search]": this.searchtext,
                categoria_contacto:this.filterCategoria,
                activo: this.filterActivo,
                recibe_correo: this.filterRecibeCorreo,
                cc_oculto: this.filterCCOculto,
            }).then((res) => {
                self.contactos = res.data;
            });
        },
        nuevoContacto(){
            let self = this;
            let routeUrl = this.$router.resolve({
                name: "cat-contacto-proveedor-nuevo",
                params: {'id_proveedor':self.id_proveedor},
            });
            window.open(routeUrl.href, "_blank");
        },
        rowClick(contacto) {
            let self = this;
            let routeUrl = this.$router.resolve({
                name: "cat-contacto-proveedor-editar",
                params: { id:contacto.id,current:contacto,id_proveedor:self.id_proveedor },
            });
            window.open(routeUrl.href, "_blank");
        },
    },
  };
  </script>